import { useEffect, useState } from "react";
import { CheckCircle2, Circle, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import api from "../../lib/api";

/* "Trip information: X% complete" + gentle "You may want to add…" prompts.
   NEVER implies legal readiness — it's a checklist of stored information only. */
const TARGETS = { segments: '[data-testid="trip-segments"]', travellers: '[data-testid="trip-travelers"]', packing: '[data-testid="trip-packing"]' };

export default function TripCompletion({ tripId, refreshKey }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/trips/${tripId}/completion`).then((r) => setData(r.data)).catch(() => {});
  }, [tripId, refreshKey]);
  if (!data) return null;

  const missing = data.items.filter((i) => !i.done);
  const jump = (i) => {
    const el = TARGETS[i.target] && document.querySelector(TARGETS[i.target]);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="border border-zinc-300 bg-white p-4 mb-8" data-testid="trip-completion">
      <div className="flex flex-wrap items-center gap-3">
        <div className="font-heading font-900">Trip information: <span data-testid="completion-pct" className="text-primary">{data.pct}% complete</span></div>
        <div className="flex-1 min-w-[140px] h-2.5 bg-zinc-100 border border-zinc-200">
          <div className="h-full bg-primary transition-all" style={{ width: `${data.pct}%` }} />
        </div>
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 mt-3">
        {data.items.map((i) => (
          <span key={i.key} className={`inline-flex items-center gap-1 text-xs ${i.done ? "text-emerald-700" : "text-zinc-400"}`}>
            {i.done ? <CheckCircle2 className="w-3.5 h-3.5" /> : <Circle className="w-3.5 h-3.5" />} {i.label}
          </span>
        ))}
      </div>
      {missing.length > 0 && (
        <div className="mt-3 border-t border-zinc-100 pt-3" data-testid="you-may-want-to-add">
          <div className="text-xs font-mono uppercase tracking-widest text-amber-700 mb-1.5">You may want to add…</div>
          <div className="flex flex-wrap gap-1.5">
            {missing.map((i) => i.target === "vault" ? (
              <Link key={i.key} to="/gear" data-testid={`add-prompt-${i.key}`}
                className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-bold border border-amber-300 text-amber-800 hover:bg-amber-50">
                <Plus className="w-3 h-3" /> {i.label}
              </Link>
            ) : (
              <button key={i.key} onClick={() => jump(i)} data-testid={`add-prompt-${i.key}`}
                className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-bold border border-amber-300 text-amber-800 hover:bg-amber-50">
                <Plus className="w-3 h-3" /> {i.label}
              </button>
            ))}
          </div>
        </div>
      )}
      <p className="text-[11px] text-muted-foreground mt-2">{data.note}</p>
    </div>
  );
}
